import { createReducer, INITIAL_STATE } from '../../../shared/redux';
import { buildAddonsApiConfig } from './addon.api';
import { LOAD_STATE } from '../../../shared/axios';

export const GET_ADDONS = '@pricing/addon/GET_ADDONS';
export const GET_PRICING_ADDONS_REQUEST_CALLED = '@pricing/addon/GET_PRICING_ADDONS_REQUEST_CALLED';
export const GET_PRICING_ADDONS_REQUEST_SUCCEEDED = '@pricing/addon/GET_PRICING_ADDONS_REQUEST_SUCCEEDED';
export const GET_PRICING_ADDONS_REQUEST_FAILED = '@pricing/addon/GET_PRICING_ADDONS_REQUEST_FAILED';

export const getAddonsData = state => state.pricing.addon.data;
export const getAddonsLoadState = state => state.pricing.addon.loadState;

export const getAddonsRequest = () => ({
    type: GET_PRICING_ADDONS_REQUEST_CALLED,
    actionTypes: {
        success: GET_PRICING_ADDONS_REQUEST_SUCCEEDED,
        fail: GET_PRICING_ADDONS_REQUEST_FAILED,
    },
    config: buildAddonsApiConfig(),
});

export const getAddons = () => ({
    type: GET_ADDONS,
    payload: {},
});

const initialState = {
    loadState: LOAD_STATE.LOADING,
    data: [],
    error: null,
};

export const addonsReducers = createReducer({
    [INITIAL_STATE]: initialState,
    [GET_PRICING_ADDONS_REQUEST_CALLED]: state => ({
        ...state,
        loadState: LOAD_STATE.LOADING,
        data: [],
        error: null,
    }),
    [GET_PRICING_ADDONS_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.SUCCESS,
        data: action.payload.data,
        error: null,
    }),
    [GET_PRICING_ADDONS_REQUEST_FAILED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.FAIL,
        data: action.payload.data,
    }),
});
